module.exports = __webpack_public_path__ + "6f1a367ec2250324a1fd16ed3ad63f73.svg";